/* eslint-disable */
import {
  SET_FEATURE_FLAGS
} from './mutation-types'

import featureFlags from '../../../services/featureFlags.service'

const state = {
  values: {}
}

const mutations = {
  [SET_FEATURE_FLAGS](state, data) {
    state.values = data
  }
}

const actions = {
  setFeatureFlags({ commit }) {
    const flags = featureFlags.getFlags()
    commit(SET_FEATURE_FLAGS, flags)
  }
}

const getters = {
  isInsightsEnabled: state => state.values.insights,
  isDealroomEnabled: state => state.values.dealroom,
  isQuickSearchPersonEnabled: state => state.values.quickSearchPerson,
  isMarketMapEnabled: state => state.values.marketMap,
  isSearchByTypeEnabled: state => state.values.searchByType,
  isProjectsEnabled: state => state.values.projects,
  isDealbookEnabled: state => state.values.dealbook,
  isMarketInsightEnabled: state => state.values.marketInsight,
  isDealHistoryEnabled: state => state.values.dealHistory,
  isShareProjectEnabled: state => state.values.shareProject,
  isVueProfileEnabled: state => state.values.newProfile,
  isDITEnabled: state => state.values.dit,
  isAFDBEnabled: state => state.values.afdb,
  isWATIHEnabled: state => state.values.watih,
  isFinsoughtFilterEnabled: state => state.values.finsoughtFilter,
  isFutureInterestEnabled: state => state.values.futureInterest,
  isCipeEnabled: state => state.values.cipe,
}

export default {
  state,
  mutations,
  actions,
  getters
}
